export const displayPriceHtml = (priceString: string, regularPriceStr: string, salePriceStr: string ) => {
  const wooStore = useWooStore();

  const regularPrice = parseInt(regularPriceStr);
  const salePrice = parseInt(salePriceStr);
  const priceHtml = convertHtml(priceString);
  const formatCurrency = sprintf(wooStore.currency.price_format, wooStore.currency.symbol, 0)?.replace('0', '') as string;

  if( priceHtml ) {
    const rate = parseFloat(wooStore.currency.rate);

    if( regularPrice == salePrice || salePrice <= 0 ) {
      const price = numberFormat(String(Math.floor(regularPrice * rate)), 0, wooStore.currency.decimal, wooStore.currency.thousand_sep, wooStore.currency.decimal_sep);
      return `<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">${formatCurrency}</span>${price}</bdi></span>`;
    }else {
      const rPrice = numberFormat(String(Math.floor(regularPrice * rate)), 0, wooStore.currency.decimal, wooStore.currency.thousand_sep, wooStore.currency.decimal_sep);
      const sPrice = numberFormat(String(Math.floor(salePrice * rate)), 0, wooStore.currency.decimal, wooStore.currency.thousand_sep, wooStore.currency.decimal_sep);
      return `<span class="w_price"><del aria-hidden="true"><span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">${formatCurrency}</span>${rPrice}</bdi></span></del><ins aria-hidden="true"><span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">${formatCurrency}</span>${sPrice}</bdi></span></ins></span>`;
    }
  }
}


export const displayPrice = (priceStr: string, showNormal: boolean = false ) => {

//return priceStr;
  const wooStore = useWooStore();
  const price =  showNormal ? parseFloat(priceStr) : parseInt(priceStr);
  const rate = parseFloat(wooStore.currency.rate) ;

  const adjustedPrice = price * rate;
  //console.log('--- adjustedPrice: ',adjustedPrice)
  const formatPriceCustom = (value: number, decimalPlaces: number) => {
    const parts = value.toFixed(decimalPlaces).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimalPlaces > 0 ? parts.join('.') : parts[0];
  };
  if (showNormal) {
    const formattedPrice = adjustedPrice.toFixed(2);
    if (formattedPrice.endsWith('.00')) {
      return `${formatPriceCustom(Math.floor(adjustedPrice), 0)}`;
    }
    return `${formatPriceCustom(adjustedPrice, 2)}`;
  }
  if (adjustedPrice < 1 && adjustedPrice > 0) {
    const decimalPart = adjustedPrice.toString().split('.')[1] || '0';
    const firstDecimal = decimalPart[0] || '0';
    return firstDecimal;
  }
  //console.log('--- adjustedPrice 222: ',Math.floor(adjustedPrice))
  return numberFormat(
    String(Math.floor(adjustedPrice)),
    0,
    wooStore.currency.thousand_sep,
    wooStore.currency.decimal_sep
  );
};
export const displaySgPrice = (price: number): number => {
  const wooStore = useWooStore();
  const rate = parseFloat(wooStore.currency.rate) || 1;
  return Math.round(price / rate);
};

export const displayCustomPrice = (price: string, showNormal: boolean = false) => {
//return price;
  const wooStore = useWooStore();
  //console.log('--- wooStore: ',wooStore)
  return convertHtml(sprintf(wooStore.currency.price_format, wooStore.currency.symbol, displayPrice(price, showNormal)));
}

export const displayTextPrice = (text: string, mask: boolean = false): string => {
  const regex = /\$(\d+)/g;
  const matches = [...text.matchAll(regex)];
  if (matches.length > 0) {
    let modifiedText = text;

    matches.forEach(match => {
      const price = match[1];
      let interPrice = displayCustomPrice(price) || '';

      if( mask ) {
        const withoutCommas = interPrice.replace(/,/g, '');
        const currencyMatch = withoutCommas.match(/([A-Z]+\$|\$|€)/);
        let currencyMask = '';
        if( currencyMatch && currencyMatch[0] ) {
          currencyMask = currencyMatch[0];
        }

        const numbers = withoutCommas.replace(/[A-Z]+\$|\$|€/g, '');

        // Keep first digit, replace rest with ?
        const firstDigit = numbers[0];
        const questionMarks = '?'.repeat(numbers.length - 1);

        interPrice = `${currencyMask}${firstDigit}${questionMarks}`;
      }
      modifiedText = modifiedText.replace(match[0], interPrice);
    });

    return modifiedText;
  }

  return text;
}

export const formatPriceByRate = (price, rateData) => {
  if (!price || isNaN(parseFloat(price))) return price;

  const rate = parseFloat(rateData?.rate || "1");
  const decimal = parseInt(rateData?.decimal || "0");

  const thousandSep = rateData?.thousand_sep || ",";
  const decimalSep = rateData?.decimal_sep || ".";
  const priceFormat = rateData?.price_format || "%1$s%2$s";
  const symbol = rateData?.symbol || "RM";

  const price2 = Math.floor(parseFloat(price));
  const calculatedPrice = Math.floor(price2 * rate);

  const formattedPrice = numberFormatByRate(
    calculatedPrice.toString(),
    decimal,
    thousandSep,
    decimalSep
  );

  return priceFormat.replace("%1$s", symbol).replace("%2$s", formattedPrice);
};

export const numberFormatByRate = (value, decimal, thousandSep, decimalSep) => {
  const parts = parseFloat(value).toFixed(decimal).split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSep);
  return parts.join(decimalSep);
};


export const displayPriceCP = (priceStr: string ) => {
  const wooStore = useWooStore();
  const price = parseInt(priceStr);
  const adjustedPrice = price * wooStore.currency.rate;
  if (adjustedPrice < 1 && adjustedPrice > 0) {
    const decimalPart = adjustedPrice.toString().split('.')[1] || '0';
    const firstDecimal = decimalPart[0] || '0';
    return firstDecimal;
  }
  return numberFormat(
    String(Math.floor(adjustedPrice))[0],
    0,
    wooStore.currency.thousand_sep,
    wooStore.currency.decimal_sep
  );
}
export const displayCustomPriceCP = (price: string) => {

  const wooStore = useWooStore();
  return convertHtml(sprintf(wooStore.currency.price_format, wooStore.currency.symbol, displayPriceCP(price)));
}
export const displayCustomPriceCP1 = (price: string) => {

  const wooStore = useWooStore();
  return convertHtml(sprintf(wooStore.currency.price_format, wooStore.currency.symbol, price));
}
export const displayTextPriceCP = (text: string): string => {
  const regex = /\$(\d+)/g;
  const matches = [...text.matchAll(regex)];
  if (matches.length > 0) {
    let modifiedText = text;

    matches.forEach(match => {
      const price = match[1];
      const interPrice = displayCustomPriceCP(price) || '';
      modifiedText = modifiedText.replace(match[0], interPrice);
    });

    return modifiedText;
  }

  return text;
}